import * as types from "@/store/constants/types";
import * as status from "@/store/constants/status";
export default {
  [types.ADD_USER](state: any, payLoad: any) {
    const { userId, userType, insUserInfo } = payLoad;
    state.currentUserId = userId;
    // state.masterUserId == null && userType === "login"
    //   ? (state.masterUserId = userId)
    //   : false;

    const findIndex = state.userList.findIndex((user: any) => {
      return user.userId.toString() === userId.toString();
    });
    const newUser = {
      userId,
      userType,
      userName: insUserInfo.username,
      userPic: insUserInfo.profile_pic_url,
      hasNoProfilePic:
        !insUserInfo.profile_pic_url ||
        insUserInfo.has_anonymous_profile_picture,
      hasNoProfileMedia: insUserInfo.media_count === 0
    };
    if (findIndex === undefined || findIndex === -1) {
      state.userList.push(newUser);
    } else {
      state.userList.splice(findIndex, 1);
      state.userList.push(newUser);
    }
  },
  [types.UPDATE_USER](state: any, payLoad: any) {
    //更新用户字段：
    const findIndex = state.userList.findIndex((user: any) => {
      return user.userId.toString() === payLoad.userId.toString();
    });
    if (findIndex !== undefined && findIndex !== -1) {
      state.userList.splice(findIndex, 1, {
        ...state.userList[findIndex],
        ...payLoad
      });
    }
  },
  [types.ADD_OTHER_APP_USER](state: any, payload: any) {
    try {
      const {
        userList,
        insUserInfoModule,
        insUserMediaModule,
        cookieModule,
        userStatusModule
      } = state;
      const { insUserList } = insUserInfoModule;
      const { insUserMediaList } = insUserMediaModule;
      const { cookieData } = cookieModule;
      const { userStatusList } = userStatusModule;
      const addUserList = payload;
      if (addUserList !== undefined && addUserList.length !== 0) {
        for (const child of addUserList) {
          const { userInfo, cookie } = child;
          const userId = parseInt(userInfo.pk);

          const newUser = {
            userId,
            userName: userInfo.username,
            userPic: userInfo.profile_pic_url,
            userType: "login",
            hasProfilePic:
              !userInfo.profile_pic_url ||
              userInfo.has_anonymous_profile_picture,
            hasProfileMedia: userInfo.media_count === 0
          };
          userList.push(newUser);

          const newInsUserInfo = {
            userId,
            insUserInfo: {},
            dataStatus: "prepare"
          };
          insUserList.push(newInsUserInfo);

          const newInsMediaInfo = {
            userId,
            maxMediaId: null,
            moreAvaliable: false,
            insMediaList: [],
            dataStatus: "prepare"
          };
          insUserMediaList.push(newInsMediaInfo);

          const newCookie = {
            userId,
            cookie
          };
          cookieData.push(newCookie);

          const newUserStatus = {
            userId,
            status: status.NORMAL, // gx的状态管理
            insStatus: status.NORMAL, //ins的状态管理
            hitCount: {
              follow: {
                count: 0,
                hitStartTimeStamp: null
              },
              like: {
                count: 0,
                hitStartTimeStamp: null
              },
              comment: {
                count: 0,
                hitStartTimeStamp: null
              }
            },
            limitedEndTimeStamp: null //限制用户的结束时间戳
          };

          userStatusList.push(newUserStatus);
        }

        //改变当前的userId:
        state.currentUserId = parseInt(addUserList[0].userInfo.pk);
      }
    } catch (error) {}
  },
  [types.DELETE_USER](state: any, payLoad: any) {
    const deleteData = (arr: any) => {
      const index = arr.findIndex((user: any) => {
        return user.userId.toString() === payLoad.toString();
      });
      if (index > -1) {
        arr.splice(index, 1);
      }
    };

    //删除列表
    deleteData(state.userList);
    //删除user_info
    deleteData(state.insUserInfoModule.insUserList);
    //删除media
    deleteData(state.insUserMediaModule.insUserMediaList);
    //删除cookie
    deleteData(state.cookieModule.cookieData);
    //删除状态
    // deleteData(state.userStatusModule.userStatusList);
  },
  [types.CLEAR_ALL_USER](state: any, payLoad: any) {
    state.currentUserId = null;
    state.currentPostId = null;
    state.currentViewId = null;
    // state.masterUserId = null;
    state.userList = [];
    state.insUserInfoModule.insUserList = [];
    state.insUserMediaModule.insUserMediaList = [];
    state.gxUserInfoModule.gxUserInfo = {};
    state.userStatusModule.userStatusList = []; //清空用户状态
    state.cookieModule.cookieData = []; //清空cookie管理
  },
  [types.CLEAR_INS_USER](state: any, payLoad: any) {
    state.currentUserId = null;
    state.currentPostId = null;
    state.currentViewId = null;
    // state.masterUserId = null;
    state.userList = [];
    state.insUserInfoModule.insUserList = [];
    state.insUserMediaModule.insUserMediaList = [];
    // state.userStatusModule.userStatusList = []; //清空用户状态
    state.cookieModule.cookieData = []; //清空cookie管理
  },
  [types.CLEAR_LOGIN_USER](state: any, payLoad: any) {
    //清除掉已经登陆的ins用户，保留search用户
    // state.masterUserId = null;
    state.gxUserInfoModule.gxUserInfo = {};
  },
  [types.CHANGE_CURRENT_USER](state: any, payLoad: any) {
    state.currentUserId = payLoad;
    //同时需要改变当前的 Media Id:
    const userMedia = state.insUserMediaModule.insUserMediaList.find(
      (item: any) => {
        return item.userId === payLoad;
      }
    );
    if (userMedia.insMediaList.length !== 0) {
      state.currentPostId = userMedia.insMediaList[0].id;
      //找出view类型的post:
      const findView = userMedia.insMediaList.find((item: any) => {
        return item.media_type === 2;
      });
      if (findView === null || findView === undefined) {
        state.currentViewId = null;
      } else {
        state.currentViewId = findView.id;
      }
    } else {
      state.currentPostId = null;
      state.currentViewId = null;
    }
  },
  [types.CHANGE_CURRENT_INS_POST_ID](state: any, payLoad: any) {
    if (payLoad === null || payLoad === undefined) {
      state.currentPostId = null;
    } else {
      state.currentPostId = payLoad.id;
    }
  },
  [types.CHANGE_CURRENT_INS_VIEW_ID](state: any, payLoad: any) {
    if (payLoad === null || payLoad === undefined) {
      state.currentViewId = null;
    } else {
      state.currentViewId = payLoad.id;
    }
  },
  [types.UPDATE_DEVICE_ID](state: any, payLoad: any) {
    if (payLoad === null || payLoad === undefined) {
      // state.deviceId = null;
    } else {
      state.deviceId = payLoad;
      state.masterUserId = payLoad; //主账号的ID为设备ID
    }
  },
  [types.UPDATE_USER_LIST](state: any, payLoad: any) {
    console.log(payLoad);
    if (payLoad === null || payLoad === undefined) {
      // state.deviceId = null;
    } else {
      const index = state.userList.findIndex(
        (v: any) => v.userId === payLoad.userId
      );
      if (index > -1) {
        payLoad.hasOwnProperty("imgUrl") &&
          (state.userList[index].userPic = payLoad.imgUrl);
        payLoad.hasOwnProperty("hasNoProfilePic") &&
          (state.userList[index].hasNoProfilePic = payLoad.hasNoProfilePic);
        payLoad.hasOwnProperty("hasNoProfileMedia") &&
          (state.userList[index].hasNoProfileMedia = payLoad.hasNoProfileMedia);
      }
    }
  }
};
